










import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IWarp10Configuration } from "sitewhere-configuration-model";

import { ContentField } from "sitewhere-ide-components";
import { VCard } from "vuetify/lib";

@Component({
  components: { VCard, ContentField }
})
export default class Warp10Summary extends Vue {
  @Prop() readonly configuration!: IWarp10Configuration;

  /** Hostname */
  get hostname(): string | null {
    return this.configuration ? this.configuration.hostname : null;
  }

  /** Port */
  get port(): number | null {
    return this.configuration ? this.configuration.port : null;
  }

  /** Application */
  get application(): string | null {
    return this.configuration ? this.configuration.application : null;
  }

  /** Token secret */
  get tokenSecret(): string | null {
    return this.configuration ? this.configuration.tokenSecret : null;
  }
}
